<template>
  <el-dialog
    :title="isCreate?'创建':'编辑'"
    :visible.sync="visible"
    :destroy-on-close="false"
    :append-to-body="true"
    :modal-append-to-body="true"
    @open="open"
    @closed="closed"
    width="50%">
    <div>
      <el-form ref="form" :model="form" label-position="top" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入标题" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input
            type="textarea"
            :autosize="{ minRows: 7, maxRows: 14}"
            placeholder="请输入内容"
            maxlength="255"
            show-word-limit
            v-model="form.content">
          </el-input>
        </el-form-item>
        <el-form-item label="附件">
          <love-element-upload
            :list-type="uploadOption.listType"
            :drag="uploadOption.drag"
            :allow-type="uploadOption.allowType"
            :allow-size="uploadOption.allowSize"
            :disabled="uploadOption.disabled"
            :limit="uploadOption.limit"
            :multiple="uploadOption.multiple"
            :love-path="uploadOption.lovePath"
            :file-list="uploadOption.fileList"
            :accept="uploadOption.accept"
            :show-file-list="uploadOption.showFileList"
            :tips="uploadOption.tips"
            @preview="onPreview"
            @remove="onRemove"
            @success="onSuccess" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="medium" type="info" @click="closed">取消</el-button>
      <axj-button color="#00adb5" size="max" @click="isCreate?handleCreate():handleUpdate()">{{isCreate?"发 布":"保 存"}}</axj-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name:'home-work-edit',
  props: {
    isCreate: {
      type: Boolean,
      default: true
    },
    source: {
      type: Object,
      default: () => ({})
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      form: {
        // id: 0,
        // title: '',
        // content: '',
        // source_directory: '',
        // competition_id: undefined,
        // user_id: undefined,
        // user_name: '',
        // user_avatar: '',
        // title: '',
        // is_comment: 1,
        // status: 1
      },
      uploadOption: {
        listType: "text",
        drag: true,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png", "application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/x-zip-compressed","application/vnd.openxmlformats-officedocument.wordprocessingml.document","application/vnd.ms-powerpoint","application/vnd.openxmlformats-officedocument.presentationml.presentation","application/msword"],
        disabled: false,
        limit: 1,
        lovePath:{
          module: "assistant/course/homework",
          source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        allowSize: 10,
        accept: '*',
        tips: "仅允许上传图片、PDF、DOC、EXCEL、PPT、ZIP等文档类型。",
        showFileList: true,
        fileList: [], // 不区分文件类型
        removeList: [], // 本次删除掉的附件
      },
      rules: {
        title: [
          { required: true, message: '请填写标题', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请填写内容', trigger: 'change' }
        ],
      }
    };
  },
  methods: {
    open() {
      this.uploadOption={
        listType: "text",
        drag: true,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png", "application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/x-zip-compressed","application/vnd.openxmlformats-officedocument.wordprocessingml.document","application/vnd.ms-powerpoint","application/vnd.openxmlformats-officedocument.presentationml.presentation","application/msword"],
        disabled: false,
        limit: 1,
        lovePath:{
          module: "assistant/course/homework",
          source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        allowSize: 10,
        accept: '*',
        tips: "仅允许上传图片、PDF、DOC、EXCEL、PPT、ZIP等文档类型。",
        showFileList: true,
        fileList: [], // 不区分文件类型
        removeList: [], // 本次删除掉的附件
      }
      // 若是父组件没有sourceDirectury 则打开dialog时创建 source_directory
      if(!this.form.source_directory) {
        this.uploadOption.lovePath.source_directory = this.info.id + '_' + Date.parse(new Date()) / 1000
        console.log("无", this.uploadOption.lovePath.source_directory)
      } else {
        this.uploadOption.lovePath.source_directory = this.form.source_directory
        console.log("有", this.uploadOption.lovePath.source_directory)
      }
      // 判断是否有附件
      if(this.form.Attachments) {
        if(this.form.Attachments.length) {
          this.uploadOption.fileList = this.form.Attachments.map(item=> {
            let attachment = {
              id: item.id,
              name: item.name,
              url: item.url,
              type: item.type
            }
            if (!(item.url.indexOf('http') >= 0)) {
              attachment.url = this.resourcePrefix.url + attachment.url
            }
            return attachment
          })
        }
      }
    },
    closed() {
      this.uploadOption.fileList = []

      this.$emit('update:show',false)
    },
    handleCreate() {
      // 表单校验
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          // 处理一下数据
          this.form.source_directory = this.uploadOption.lovePath.source_directory
          this.form.user_id = this.info.id
          this.form.user_name = this.info.nickname
          this.form.user_avatar = this.info.avatar
          this.$emit('create', this.form, this.uploadOption.fileList)
        }
      })
    },
    handleUpdate() {
      // 表单校验
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.$emit('update', this.form, this.uploadOption.fileList,  this.uploadOption.removeList)
        }
      })
    },
    onPreview(file) {
      console.log(file)
      console.log(this.uploadOption.fileList)
    },
    onRemove(file, fileList) {
      // 若是有 id
      if(file.id){
        // 记录
        this.uploadOption.removeList.push(file.id)
      }
      this.uploadOption.fileList = fileList.map(item => {
        if (typeof(item.response) != 'undefined') {
          return {
            uid: item.uid,
            name: item.response.old_name,
            url: item.response.url,
            type: item.response.file_extension, // 数据库目前使用的 type 是以文件后缀决定 ( 2020-04-09 APP端给的统以要求 )
            status: item.status
          }
        }
        return item
      })
      console.log(file)
      console.log(fileList)
      console.log(this.uploadOption.fileList)
    },
    onSuccess(response) {
      // 保存返回值
      const file = {
        uid: response.uid,
        name: response.old_name,
        url: response.url,
        // type: response.type,
        type: response.file_extension, // 数据库目前使用的 type 是以文件后缀决定 ( 2020-04-09 APP端给的统以要求 )
        status: "success"
      }
      // 更新 fileList
      this.uploadOption.fileList[this.uploadOption.fileList.length] = file
    },
  },
  computed: {
    info(){
      return this.$store.getters.getUser.info
    },
    resourcePrefix(){
      return this.$store.getters.getResourcePrefix
    }
  },
  watch: {
    show() {
      this.visible = this.show
    },
    source() {
      this.form = this.source
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/axj-help/axj-course/component/home-work/component/home-work-edit/index.vue